import Model from '@/store/plugins/orm/Model';
import HashGen from '@/utilities/HashGen';
import { Product, ProductCategory } from './ModelRepository';

export class KitchenTicketItem extends Model {
    static get entity() {
        return 'kitchen_ticket_items';
    }

    static get primaryKey() {
        return 'hash';
    }

    static get DATE_FORMAT() {
        return 'YYYY-MM-DDTHH:mm:ssZ';
    }

    static fields() {
        return {
            id: this.attr(null),
            hash: this.attr(HashGen.regular()),
            kitchen_ticket_id: this.attr(null),
            kitchen_ticket_hash: this.attr(null),
            order_item_id: this.attr(null),
            order_item_hash: this.attr(null),
            product_id: this.attr(null),
            name: this.attr(null),
            count: this.attr('1.000', (value) => _.round(value, 3).toFixed(3)),
            comments: this.attr([], (value) => value || []),
            completed_at: this.attr(null)
        };
    }

    complete(complete = true) {
        if (!complete) {
            this.completed_at = null;
            return;
        }

        this.completed_at = moment().utc().format(KitchenTicketItem.DATE_FORMAT);
    }

    getProduct() {
        return Product.all().find(product => product.id === this.product_id);
    }

    getCategory() {
        const product = Product.find(this.product_id);
        return ProductCategory.find(product?.category_id)
    }
}

export default KitchenTicketItem;
